import type { PageLoad } from "./$types";
import { getDoSpacesUrl } from "$lib/utility/image";

type SimilarCompany = {
  id: number;
  name: string;
  slug: string;
  domain: string;
  description: string;
  gravatarUrl: string;
  key: string;
};

const loadSimilarCompanies = async (origin: string, companiesIds: number[]) => {
  try {
    const similarCompaniesRes = await fetch(origin + "/api/v1/search/get_similar_companies", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        companiesIds,
      }),
    });

    const similarCompanies: { similarCompanies: SimilarCompany[] } = await similarCompaniesRes.json();

    return (
      similarCompanies.similarCompanies?.map((company) => ({
        ...company,
        smallLogoThumbUrl: getDoSpacesUrl(company.key) || company.gravatarUrl,
      })) || []
    );
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const load = (async ({ url, parent }) => {
  const { similarCompanies } = await parent();
  return {
    similarCompanies: loadSimilarCompanies(url.origin, similarCompanies),
  };
}) satisfies PageLoad;
